import { defineMessages } from "utils/defineMessages";

export const scope = "app.components.EmailOtp";

export default defineMessages(scope, {
  title: "Set up Email Authentication",
  subtitle: "Enter the 6-digit code sent to your email address.",
  codePlaceholder: "Verification Code",
  submitButton: "Verify",
  resendButton: "Resend code",
  resendCountdown: "Resend code in {count}",
  cancelButton: "Cancel",
  sending: "Sending code…",
  mfaTitle: "Email OTP",
  mfaDescription:
    "Uses a one-time code sent to your email to verify your identity during sign-in",
  mfaLabel:
    "Set up email OTP. Enter the six digit code sent to your email address.",
  errorEmpty: "Please enter the code.",
  errorInvalid: "Invalid or expired code. Please try again.",
  errorGeneric: "Something went wrong. Please try again.",
  removeTitle: "Remove Email Authentication",
  removeSubtitle:
    "Are you sure you want to remove email authentication? You will no longer receive one-time codes via email.",
  confirmRemove: "Remove",

  otpInformationMessage:
    "Email code is valid for 5 minutes. Requesting a new code invalidates any previous code.",
  errorMaxResendAttempts: "Maximum resend attempts reached.",
});
